import { ADMIN_ACTOR_IDENTIFIERS, SYSTEM_ACTOR_IDENTIFIERS } from "@/common/constants/logs/internalActorIdentifiers";

const matchesIdentifier = (normalizedValue: string, identifiers: string[]) =>
  identifiers.some((identifier) => normalizedValue.includes(identifier));

export const isInternalLogActor = (indicator?: string | null) => {
  if (!indicator) return false;

  const normalized = indicator.trim().toLowerCase();
  if (!normalized) return false;

  return (
    matchesIdentifier(normalized, SYSTEM_ACTOR_IDENTIFIERS) ||
    matchesIdentifier(normalized, ADMIN_ACTOR_IDENTIFIERS)
  );
};
